import { SORTING_DIR } from "@/common/models";
import { ITableConfig } from "@/components/table/table.model";

export const table_config: ITableConfig = {
  columns: [
    {
      name: "Name",
      key: "name",
      spanMin: "14rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      jsPath: "$[*].name",
    },
    {
      name: "Department",
      key: "department",
      spanMin: "12rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].department",
    },
    {
      name: "Day",
      key: "day",
      spanMin: "17rem",
      spanMax: "17rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].day",
    },
    {
      name: "#Downloads",
      key: "download_count",
      spanMin: "14rem",
      spanMax: "14rem",
      alignLeft: true,
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].score",
    },
    {
      name: "Investigate",
      key: "",
      spanMin: "8rem",
      spanMax: "8rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
    },
  ],
};
